module.exports = __webpack_public_path__ + "static/media/tiger.2e028751.jpg";